import { call, put, takeLatest } from 'redux-saga/effects';
import { API } from '../api';
import { FETCH_OCPI_PARTNER_PRICING, DELETE_OCPI_PARTNER_PRICING, UPDATE_OCPI_PARTNER_PRICING, CREATE_OCPI_PARTNER_PRICING, GET_OCPI_PARTNER_PRICING } from 'actions/ocpiPartnerPricing';

function* fetchOcpiPartnerPricing(action) {
  try {
    const response = yield call(API.getOcpiPartnerPricing, action.payload);
    yield put({ type: FETCH_OCPI_PARTNER_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: FETCH_OCPI_PARTNER_PRICING.FAIL, payload: { error: e } });
  }
}

function* getOcpiPartnerPricing(action) {
  try {
    const response = yield call(API.getOcpiPartnerPricingById, action.payload);
    yield put({ type: GET_OCPI_PARTNER_PRICING.SUCCESS, payload: response.data });
  } catch (e) {
    yield put({ type: GET_OCPI_PARTNER_PRICING.FAIL, payload: { error: e } });
  }
}

function* createOcpiPartnerPricing(action) {
  try {
    const response = yield call(API.addOcpiPartnerPricing, action.payload);
    yield put({ type: CREATE_OCPI_PARTNER_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: CREATE_OCPI_PARTNER_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* updateOcpiPartnerPricing(action) {
  try {
    const response = yield call(API.updateOcpiPartnerPricing, action.payload);
    yield put({ type: UPDATE_OCPI_PARTNER_PRICING.SUCCESS, payload: response.data });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: UPDATE_OCPI_PARTNER_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* deleteOcpiPartnerPricing(action) {
  try {
    const response = yield call(API.deleteOcpiPartnerPricing, action.payload);
    yield put({ type: DELETE_OCPI_PARTNER_PRICING.SUCCESS, payload: action.payload });
    action.cb && action.cb(response);
  } catch (e) {
    yield put({ type: DELETE_OCPI_PARTNER_PRICING.FAIL, payload: { error: e } });
    action.cb && action.cb(e);
  }
}

function* ocpiPartnerPricing() {
  yield takeLatest(FETCH_OCPI_PARTNER_PRICING.REQUEST, fetchOcpiPartnerPricing);
  yield takeLatest(GET_OCPI_PARTNER_PRICING.REQUEST, getOcpiPartnerPricing);
  yield takeLatest(CREATE_OCPI_PARTNER_PRICING.REQUEST, createOcpiPartnerPricing);
  yield takeLatest(UPDATE_OCPI_PARTNER_PRICING.REQUEST, updateOcpiPartnerPricing);
  yield takeLatest(DELETE_OCPI_PARTNER_PRICING.REQUEST, deleteOcpiPartnerPricing);
}
export default ocpiPartnerPricing;
